import './style.scss';

function iconboxRenderer($block) {

}

// Initialize dynamic block preview (editor).
if( window.acf ) {
	window.acf.addAction( 'render_block_preview/type=iconbox', iconboxRenderer );
}